import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  setActiveTest
} from '../../actions/client';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
  BS_TEST,
  LF_TEST,
} from '../../constants.js';
import s from './Tests.css';

class Tests extends PureComponent {

  selectTest(name) {
    this.props.setActiveTest(name);
  }

  checkIfCompleted(name) {
    const completed = this.props.testData.results.filter((result) => result.name === name);
    return completed.length > 0 ? true : false;
  }

  render() {
    const { activeTest } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className={s.headerRow}></div>
            <div className={s.headerTitle}>Your Behavioral Finance Assessment</div>
          </div>
        </div>
        { activeTest === '' &&
          <div className="row">
            <div className="col-md-1"></div>
            <div className={`col-md-10 ${s.copy}`}>
            The following assessments will reveal the preferences, needs and tendencies that shape your most important financial decisions. Your answers will help your advisor consider potential WisdomTree models. The complete assessment will consist of four different surveys and take about ten minutes.
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-12" style={{textAlign: 'center'}}>
              <button onClick={() => this.selectTest('begin')} className={s.answerButton}>BEGIN</button>
            </div>
          </div>
        }
        { activeTest === 'begin' &&
          <div className="row">
            <div className="col-md-1"></div>
            <div className={`col-md-10 ${s.copy}`}>
            Many investors are stuck with portfolios that are not suited to their actual feelings about losses, which can lead to expensive money mistakes, such as buying high and selling low.
            <br /><br />
            This short survey measures how you feel about losses, and will help your advisor devise an appropriate investment strategy.
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-12" style={{textAlign: 'center'}}>
              <button onClick={() => this.selectTest(LA_TEST)} className={s.answerButton}>NEXT</button>
            </div>
          </div>
        }
        { activeTest === 'end' &&
          <div className="row">
            <div className="col-md-1"></div>
            <div className={`col-md-10 ${s.copy}`}>
            Thank you for taking the time to complete your behavioral finance assessment.
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-12" style={{textAlign: 'center'}}>
              {/* <button onClick={() => this.selectTest('')} className={s.answerButton}>DONE</button> */}
            </div>
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    testData: state.clientData.testData,
    activeTest: state.clientData.activeTest,
  };
}

export default connect(mapStateToProps,{
  setActiveTest,
})(Tests);



// WEBPACK FOOTER //
// ./src/components/ClientMode/Tests.js